export const CLEAR_VIDEO = 'CLEAR_VIDEO';
export const SET_MODULE_LIST = 'SET_MODULE_LIST';
export const SET_SECTION_LIST = 'SET_SECTION_LIST';
export const setModuleList = data => ({ type: SET_MODULE_LIST, data });
export const setSectionList = data => ({ type: SET_SECTION_LIST, data });
export const clearVideo = () => ({ type: CLEAR_VIDEO });
